import type { IDAChatMessage } from "./chatMessageMapper";

const CLIENT_GENERATED_ID_THRESHOLD = 1000000000;

type DeleteMessageCandidate = Pick<
  IDAChatMessage,
  "id" | "hubMessageId" | "role" | "content"
>;

function parseHubMessageId(value: string | number | undefined): number | null {
  if (typeof value === "number" && Number.isInteger(value)) {
    return value < CLIENT_GENERATED_ID_THRESHOLD ? value : null;
  }

  if (typeof value === "string" && /^\d+$/.test(value)) {
    const parsed = parseInt(value, 10);
    return parsed < CLIENT_GENERATED_ID_THRESHOLD ? parsed : null;
  }

  return null;
}

export function resolveDeleteHubMessageId(
  localMessage: DeleteMessageCandidate,
  serverMessages: DeleteMessageCandidate[],
): number | null {
  const directHubId =
    parseHubMessageId(localMessage.hubMessageId) ??
    parseHubMessageId(localMessage.id);

  if (directHubId !== null) {
    return directHubId;
  }

  const matchedServerMessage = [...serverMessages]
    .reverse()
    .find(
      (message) =>
        message.role === localMessage.role &&
        message.content === localMessage.content &&
        parseHubMessageId(message.hubMessageId ?? message.id) !== null,
    );

  if (!matchedServerMessage) {
    return null;
  }

  return (
    parseHubMessageId(matchedServerMessage.hubMessageId) ??
    parseHubMessageId(matchedServerMessage.id)
  );
}
